// extracted by mini-css-extract-plugin
export default {"itemLine":"HasKidsPrice_itemLine__IB95D"};